import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {CostService} from '../../../../../services/cost/cost.service';
import {Cost} from '../../../../../models/cost';
import { DatePipe } from '@angular/common';
import {MoneyPipe} from '../../../../../pipes/money/money.pipe';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSortPipe} from '../../../../../pipes/table-sort/table-sort.pipe';
import {TableFilterHeaderComponent} from '../../../../layout/table-filter-header/table-filter-header.component';
import {TableFilterDirective} from '../../../../../directives/table-filter/table-filter.directive';
import {TableFilter} from '../../../../../tools/table-filter/table-filter';
import {TableFilterPipe} from '../../../../../pipes/table-filter/table-filter.pipe';

@Component({
  selector: 'app-cost-detail',
  imports: [
    MoneyPipe,
    DatePipe,
    TableSorterDirective,
    TableSorterHeaderDirective,
    TableSortPipe,
    TableFilterHeaderComponent,
    TableFilterDirective,
    TableFilterPipe
],
  templateUrl: './cost-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cost-detail.component.scss'
})
export class CostDetailComponent implements Dialog {
  costs: Cost[] = [];

  tableFilter: TableFilter = new TableFilter();
  tableSorter: TableSorter = new TableSorter('partner', 'asc');

  filters: any = {
    key: new Date().toISOString().split('T')[0],
    groupBy: 'date-day',
  };

  filterAllocatedChoices = [
    { label: 'All', value: '' },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ];

  constructor(
    private loader: LoaderService,
    private costService: CostService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.visible = false;
    this.loader.startLoading();

    this.filters.key = params.data.key;
    this.filters.groupBy = params.data.filters.groupBy;
    this.filters.startDate = params.data.filters.startDate;
    this.filters.endDate = params.data.filters.endDate;

    if (params.data.filters.partnerId) {
      this.filters.partnerId = params.data.filters.partnerId;
    }

    if (params.data.filters.advertisingPlatformId) {
      this.filters.advertisingPlatformId = params.data.filters.advertisingPlatformId;
    }

    this.costService.findAll(this.filters).subscribe(costs => {
      this.costs = costs;

      this.loader.stopLoading();
      params.visible = true;
    });
  }

  getTotal(column: string): number {
    let value = 0;
    let pipe = new TableFilterPipe();
    let costs = pipe.transform(this.costs, this.tableFilter);

    costs.forEach((cost: any) => {
      if (!isNaN(cost[column])) {
        value += parseFloat(cost[column]);
      }
    });

    return value;
  }
}
